import AssignmentJobViewPage from '@/pages/assignments/job-view'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventAssignmentDetailsPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <AssignmentJobViewPage />
    </WorkspacePortalProvider>
  )
}
